export default __webpack_public_path__ + "static/media/lightmemoji.0e934c11.jpg";